import {
  iconCommonProps, iconDefaultProps, iconPropTypes
} from '../propTypes';

const Tick = ({ className, color }) => (
  <svg
    className={ className }
    { ...iconCommonProps }
    viewBox='0 0 406.834 406.834'
  >
    <g>
      <polygon
        fill={ color }
        points='385.621,62.507 146.225,301.901 21.213,176.891 0,198.104 146.225,344.327 406.834,83.72'
      />
    </g>
  </svg>
);

Tick.propTypes = { ...iconPropTypes };

Tick.defaultProps = { ...iconDefaultProps };

export default Tick;